import { render, staticRenderFns } from "./GSbyExecutive.vue?vue&type=template&id=63b725a5&scoped=true&"
import script from "./GSbyExecutive.vue?vue&type=script&lang=js&"
export * from "./GSbyExecutive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b725a5",
  null
  
)

export default component.exports